<template>
  <div class="directorWrap">
    <el-dialog class="dialogWrap" title="" :visible.sync="visible" width="1200px" top="1vh" :close-on-click-modal="false" append-to-body>
      <div class="pb30">
        <el-tabs v-model="memberType" @tab-click="cutType">
          <!-- 添加公司 -->
          <el-tab-pane :label="$t('enroll.intitle.addCompany')" name="CORPORATE" :disabled="isReadonly">
            <!-- 公司类型 - 表单面板 -->
            <company-form-panel ref="companyPanel" :form="companyForm" :fundInfoList="fundInfoList" :isReadonly="isReadonly"></company-form-panel>
          </el-tab-pane>

          <!-- 添加个人 -->
          <el-tab-pane :label="$t('enroll.intitle.addPersonal')" name="INDIVIDUAL" :disabled="isReadonly">
            <!-- 个人类型 - 表单面板 -->
            <personal-form-panel ref="personalPanel" :form="personalForm" :fundInfoList="fundInfoList" :isReadonly="isReadonly"></personal-form-panel>
          </el-tab-pane>
        </el-tabs>
        <div class="pt20 wdb100 fxRow" v-if="!isReadonly">
          <el-button type="primary" @click="handleSubmit" class="pl20 pr20">{{ $t("common.button.affirm") }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CompanyFormPanel from "./CompanyFormPanel.vue";
import PersonalFormPanel from "./PersonalFormPanel.vue";
import { createCompanyForm, createPersonalForm, normalizeCompanyForm, normalizePersonalForm } from "./formFactory";

export default {
  name: "FundDirectorAddOrUpdate",
  components: { CompanyFormPanel, PersonalFormPanel },
  props: {
    /** 基金信息列表（供关联选择） */
    fundInfoList: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      memberType: "CORPORATE",
      companyForm: createCompanyForm(),
      personalForm: createPersonalForm(),
      getInfoIdx: null,
    };
  },
  methods: {
    init(index, row) {
      this.getInfoIdx = index;
      if (index === "add") {
        this.companyForm = createCompanyForm();
        this.personalForm = createPersonalForm();
        this.memberType = "CORPORATE";
        this.$nextTick(() => this.clearValidate());
      } else {
        const rowRes = JSON.parse(JSON.stringify(row));
        // fundsInfo 兼容 JSON 字符串数组等历史数据形态，统一在 normalize 中处理
        this.memberType = rowRes.memberType || "INDIVIDUAL";
        if (this.memberType === "CORPORATE") {
          this.companyForm = normalizeCompanyForm(rowRes);
          this.personalForm = createPersonalForm();
          this.$nextTick(() => this.clearValidate());
        } else {
          this.personalForm = normalizePersonalForm(rowRes);
          this.companyForm = createCompanyForm();
          this.$nextTick(() => this.clearValidate());
        }
      }
      // 为空的号码设置默认区号 65(新加坡)
      if (!this.companyForm.phone) this.companyForm.phone = "65-";
      if (!this.companyForm.representativeInfo.phone) this.companyForm.representativeInfo.phone = "65-";
      if (!this.personalForm.phone) this.personalForm.phone = "65-";
      this.visible = true;
    },
    /** 统一清除面板表单校验状态 */
    clearValidate() {
      if (this.$refs.companyPanel) this.$refs.companyPanel.clearValidate();
      if (this.$refs.personalPanel) this.$refs.personalPanel.clearValidate();
    },
    // 切换 tab
    cutType() {
      this.clearValidate();
    },
    // 确认提交(由面板触发校验)
    handleSubmit() {
      const panelRef = this.memberType === "CORPORATE" ? this.$refs.companyPanel : this.$refs.personalPanel;
      const formTypeCopy = this.memberType === "CORPORATE" ? this.companyForm : this.personalForm;

      // DIRECTOR 类型不展示股份信息
      if (this.memberType === "INDIVIDUAL" && formTypeCopy.positionHeld === "DIRECTOR") {
        this.$set(formTypeCopy, "information", null);
        this.$set(formTypeCopy, "sharesInfo", []);
      } else {
        this.$set(formTypeCopy, "information", formTypeCopy.sharesInfo && formTypeCopy.sharesInfo.length !== 0 ? "ok" : null);
      }

      panelRef.validate(valid => {
        if (!valid) return;

        this.$emit("update", formTypeCopy, this.getInfoIdx);
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* ====== dialogWrap 深度选择器 ====== */
.dialogWrap ::v-deep {
  .el-dialog__header {
    padding: 15px 20px;
  }
  .el-dialog__headerbtn {
    top: 8px;
    right: 15px;
    font-size: 20px;
  }
  .el-tabs__header {
    margin: 0 0 20px;
  }
  .el-tabs__nav {
    float: none;
    text-align: center;
  }
  .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
    padding: 0;
    margin: 0 40px;
    &.is-active {
      border-bottom: 2px solid;
    }
  }
  .el-tabs__nav-wrap::after {
    height: 0;
  }
  .el-tabs__active-bar {
    height: 0;
    display: none;
  }
}
</style>
